import React from "react";
import { Row, Col, Typography, Space, Button, Modal } from "antd";
import Styles from "./SameAddressPopup.module.scss";
import { useWindowSize } from "../../../../hooks/useWindowSize";
import { GeneralDefinition } from "../../../../types/ApplicationTypes";

type Props = {
    isNotSameAddress: boolean;
    handleCancelSameAddress: () => void;
};

const SameAddressPopup: React.FC<Props> = ({
    isNotSameAddress,
    handleCancelSameAddress
}) => {
    const { width } = useWindowSize();

    return width > GeneralDefinition.MobileView ? (
        <Modal
            onCancel={handleCancelSameAddress}
            visible={isNotSameAddress}
            okButtonProps={{ hidden: true }}
            cancelButtonProps={{ hidden: true }}
            centered={true}
            footer={
                <Row className={Styles.modalContainer}>
                    <Col span={24}>
                        <Row justify="center">
                            <Typography.Text className={Styles.modalHeaderClose}>
                                Invalid Address
                            </Typography.Text>
                        </Row>
                        <Row justify="center" className={Styles.addressSection}>
                            <Col>
                                <Row justify="center">
                                    <Col className={Styles.modalBodyText}>
                                        The pickup address and dropoff address
                                    </Col>
                                </Row>
                                <Row justify="center">
                                    <Col className={Styles.modalBodyText}>
                                        cannot be the same.
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row justify="center" className={Styles.addressSection}>
                            <Col className={Styles.modalBtn}>
                                <Space>
                                    <Button
                                        className={Styles.buttonThemeBlueClose}
                                        onClick={handleCancelSameAddress}
                                    >
                                        Close
                                    </Button>
                                </Space>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            }
        />
    ) : (
        <Modal
            onCancel={handleCancelSameAddress}
            visible={isNotSameAddress}
            okButtonProps={{ hidden: true }}
            cancelButtonProps={{ hidden: true }}
            centered={true}
            footer={
                <Row className={Styles.modalContainer}>
                    <Col span={24}>
                        <Row justify="center">
                            <Typography.Text className={Styles.modalHeaderClose}>
                                Invalid Address
                            </Typography.Text>
                        </Row>
                        <Row justify="center" className={Styles.addressSection}>
                            <Col>
                                <Row justify="center">
                                    <Col className={Styles.modalBodyText}>
                                        The pickup address and dropoff address cannot be the same.
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row justify="center" className={Styles.addressSection}>
                            <Col className={Styles.modalBtn}>
                                <Space>
                                    <Button
                                        className={Styles.buttonThemeBlueClose}
                                        onClick={handleCancelSameAddress}
                                    >
                                        Close
                                    </Button>
                                </Space>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            }
        />
    );
};

export default SameAddressPopup;
